import React from 'react'
import styles from './insights.module.scss'
import { formatPence } from './insightsStats'

const StatList = ({ title, items, emptyText = 'None' }) => (
  <div className={styles.partyStatsSection}>
    <h4>{title}</h4>
    {items.length === 0 ? (
      <p>{emptyText}</p>
    ) : (
      items.map(({ name, value }) => (
        <p key={name}>
          {name}: {value}
        </p>
      ))
    )}
  </div>
)

const PartyStatsDisplay = ({
  partyStats,
  title = 'Party overview'
}) => {
  if (!partyStats || partyStats.totalParties === 0) {
    return <p>No parties in this range</p>
  }

  return (
    <div className={styles.partyStats}>
      <h3>{title}</h3>
      <p>Total parties: {partyStats.totalParties}</p>
      <p>Total children: {partyStats.totalChildren}</p>
      <p>Average children per party: {partyStats.avgChildrenPerParty}</p>
      <p>Extra guests: {partyStats.totalExtraGuests}</p>
      <p>Young siblings: {partyStats.totalYoungSiblings}</p>
      <p>Total guests (all): {partyStats.totalGuests}</p>
      <p>Total booking value: {formatPence(partyStats.totalRevenuePence)}</p>
      <p>Deposits collected: {formatPence(partyStats.totalDepositsPence)}</p>
      {partyStats.totalDiscountedPence > 0 && (
        <p>After discounts: {formatPence(partyStats.totalDiscountedPence)}</p>
      )}
      {partyStats.wheelchairAccess > 0 && (
        <p>Wheelchair access required: {partyStats.wheelchairAccess}</p>
      )}
      <StatList title="Birthday child ages" items={partyStats.childAges} />
      <StatList title="Party reasons" items={partyStats.partyReasons} />
      <StatList title="Menu options" items={partyStats.menuOptions} />
      <StatList title="Time slots" items={partyStats.timeSlots} />
      <StatList
        title="Popular add-ons (themes, extras & mascots)"
        items={partyStats.popularAddOns}
        emptyText="No add-ons ordered"
      />
    </div>
  )
}

export default PartyStatsDisplay
